import { render, staticRenderFns } from "./levelAnnouncement.vue?vue&type=template&id=151ecf7d"
import script from "./levelAnnouncement.vue?vue&type=script&lang=js"
export * from "./levelAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./levelAnnouncement.vue?vue&type=style&index=0&id=151ecf7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports